import { render, staticRenderFns } from "./teamCreate.vue?vue&type=template&id=a6d5a5f2&scoped=true&"
import script from "./teamCreate.vue?vue&type=script&lang=js&"
export * from "./teamCreate.vue?vue&type=script&lang=js&"
import style0 from "./teamCreate.vue?vue&type=style&index=0&id=a6d5a5f2&prod&lang=less&scoped=true&"
import style1 from "./teamCreate.vue?vue&type=style&index=1&id=a6d5a5f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d5a5f2",
  null
  
)

export default component.exports